import { render, staticRenderFns } from "./SessionOverlappings.vue?vue&type=template&id=87d94818&"
import script from "./SessionOverlappings.vue?vue&type=script&lang=js&"
export * from "./SessionOverlappings.vue?vue&type=script&lang=js&"
import style0 from "./SessionOverlappings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports